import { render } from "./ScormManager.vue?vue&type=template&id=0b091151&scoped=true"
import script from "./ScormManager.vue?vue&type=script&lang=js"
export * from "./ScormManager.vue?vue&type=script&lang=js"

import "./ScormManager.vue?vue&type=style&index=0&id=0b091151&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b091151"]])

export default __exports__